import { Select } from "@mantine/core";
import {
  IAfterGuiAttachedParams,
  IDoesFilterPassParams,
} from "ag-grid-enterprise";
import { CustomFilterProps, useGridFilter } from "ag-grid-react";
import { useCallback, useRef } from "react";

export default ({ model, onModelChange, getValue }: CustomFilterProps) => {
  const refInput = useRef<HTMLInputElement>(null);
  const doesFilterPass = useCallback(
    (params: IDoesFilterPassParams) => {
      const { node } = params;
      const filterText: string = model;
      const value: string = getValue(node).toString().toLowerCase();
      // make sure each word passes separately, ie search for firstname, lastname
      const result = filterText
        .toLowerCase()
        .split(" ")
        .every((filterWord) => value.indexOf(filterWord) >= 0);
      return result;
    },
    [model]
  );

  const afterGuiAttached = useCallback((params?: IAfterGuiAttachedParams) => {
    if (!params || !params.suppressFocus) {
      // Focus the input element for keyboard navigation.
      // Can't do this in an effect,
      // as the component is not recreated when hidden and then shown again
      refInput.current?.focus();
    }
  }, []);

  // register filter handlers with the grid
  useGridFilter({
    doesFilterPass,
    afterGuiAttached,
  });

  const statusPromotion = [
    {
      value: "1",
      label: "Chưa duyệt",
    },
    {
      value: "2",
      label: "Đã duyệt",
    },
    {
      value: "3",
      label: "Tạm dừng",
    },
    {
      value: "4",
      label: "Từ chối",
    },
    {
      value: "5",
      label: "Hủy duyệt",
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      <Select
        searchable
        clearable
        comboboxProps={{
          transitionProps: { transition: "fade-up", duration: 200 },
        }}
        mt={10}
        size="xs"
        data={statusPromotion}
        multiple={true}
        onChange={(value) => {
          onModelChange({
            filter: value === null ? "" : value,
            filterType: "text",
            type: "contains",
          });
        }}
        width={"100%"}
        nothingFoundMessage="Dữ liệu không có !"
      />
    </div>
  );
};
